import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Onboarding</Typography>

      <p>Start by choosing your organisation. If you are signing up as a company we require a little more information than if you sign up personally or for a small organisation.</p>

      <p>You can always update this information later if your details change.</p>

      <Typography variant='h6' className='pt-5'>Smartix Scan</Typography>
      <p>You may enable access to Smartix Scan app (if you wish to use it). However, we recommend that you create a separate user (once you have completed onboarding) to the this.
        This maintains a separation between your administrative account and your day-to-day operations. If you are a sole user, then it may be more convienient to use a single account.</p>

      <Typography variant='h6' className='pt-5'>Preferred data format</Typography>
      <p>When you download or upload pass data in Studio you can use JSON, CSV or MS Excel. You can choose which one you want at the time. Your selection here simply sets your default value. You can change this at any time in settings.</p>

      <Typography variant='h6' className='pt-5'>Company details</Typography>
      <p>If we need to speak to you about your account, we will always start by contacting your main contact.</p>
      <p>Invoices are always accessible from within Studio. We will also email a copy to your billing contact.</p>

      <Typography variant='h6' className='pt-5'>Wallet credentials</Typography>
      <p>Secure credentials are required to register wallet passes with Apple and Google.</p>

      <p>You can either allow Smartix to generate and manage these credentials for you (most clients choose this option), or you may provide your own credentials issued to your own Apple and Google accounts.</p>

      <p>Using Smartix-managed credentials is the simplest option and makes no difference to how your pass data is stored or managed. Using your own credentials gives your organisation direct ownership of its Apple and Google Wallet identities and provides a potential migration path should you ever stop using Smartix. Please speak to us if you require more information about this.</p>

      <p>Having your own Apple and Google developer accounts does have a cost. As of September 2026, Google charge a one-off US$25 fee and Apple charge £79 per year.</p>

      <p>If you wish to use your own credentials, you can still start by using Smartix credentials for initial evaluation. To switch later, all templates and passes created in the evaluation account must be deleted first. You can request a switch by contacting Smartix Support.</p>

      <Typography variant='h6' className='pt-5'>Agreements</Typography>
      <p>Please read our agreements. They detail how Smartix operatates, what you can expect from us and what we expect from you. We have additional documents details data protection etc. that you can read <a href="https://docs.smartix.uk/terms/payg-terms/" target='_blank' rel='noreferrer' className="link">here</a></p>

      <Typography variant='h6' className='pt-5'>Providing your own wallet credentials</Typography>
      <p>If you elect to use your own credentials then you will be presented with an additonal form where you can enter them. You can find instruction below:</p>
      <ul>
        <li><a href="https://docs.smartix.uk/smartix-onboarding-apple-credentials-setup.pdf" target='_blank' rel='noreferrer' className="link">Apple setup instructions</a></li>
        <li><a href="https://docs.smartix.uk/smartix-onboarding-google-credentials-setup.pdf" target='_blank' rel='noreferrer' className="link">Google setup instructions</a></li>
      </ul>

    </div>
  )
}

export default HelpText